import Vue from 'vue'
import VueEvents from 'vue-events'

Vue.use(VueEvents)

import PostMixins from '@/mixins/PostMixins'

export default {

  mixins: [PostMixins],

  methods: {

    formatPhotoRequred (value) {
      return value ? '<b class="el-icon-check"></b>' : ''
    },

    setEditState (add = false) {
      if (this.isSiteManager || add) {
        this.editable = true
        this.editing = (add ? true : false)
        this.disabled = (add ? false : true)
        this.deletable = (add ? false : true)
      }
    }
  },

  computed: {
    isSiteManager: function () {
      return this.isManager() && this.canAccess('project|maintenance') && this.isTowerCo()
    }
  },

  data () {
    return {
      workflowOption: ['Audit', 'Corrective', 'Preventive', 'New', 'Construction', 'Upgrading', 'Installation', 'Dismantling', 'Permits'],
      wfCategoryOption: ['Grounds', 'Electrial', 'Structure', 'Equipment', 'Power', 'Repairs', 'Permits'],
      unitsOption: ['Minute', 'Hour', 'Day', 'Week'],
      categoryOption: ['General Maintenance', 'Grounds Maintenance', 'Building Maintenance', 'Tower Safety', 'Tower Maintenance', 'Electrical', 'Electrical Safety', 'Security', 'Power', 'Lighting', 'Other', 'Permits'],
      ticketOptions: [
        {
          value: 'Pending',
          label: 'Pending'
        },
        {
          value: 'In Progress',
          label: 'In Progress'
        },
        {
          value: 'KIV',
          label: 'KIV'
        },
        {
          value: 'Escalated',
          label: 'Escalated'
        },
        {
          value: 'Finished',
          label: 'Finished'
        }
      ],
      WORKFLOW_TABLE_REF: 'workflowtable',
      SITE_WORKFLOW_TABLE_REF: 'siteWorkflowTable',
      CHECKLIST_TABLE_REF: 'checklisttable',
      disabled: true,
      editing: false,
      editable: false,
      deletable: false
    }
  }
}
